import Loader from "react-loader-spinner";
import { useRef, useState } from "react";
import { Button, Col, Form, Modal, Row, Table } from "react-bootstrap";
import { getEntityTypes } from "../../store/api/workItemLinksApi";
import { setErrorDialog } from "../../../store/api/CommonFunctions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
export default function ModalWorkItemLinks({ show, setShow, onSelect }) {
    const searchDataRef = useRef({});
    const [serchError, setSearchError] = useState(null);
    const [isPending, setIsPending] = useState(false);
    const [searchData, setSearchData] = useState(null);
    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        searchDataRef.current[name] = value;
    }
    const handleSearch = async () => {
        setIsPending(true);
        const result = await getEntityTypes(searchDataRef.current.entityType, searchDataRef.current.code);
        setIsPending(false);
        if (result?.Message) {
            setSearchError(result.Message);
        }
        else if (result?.Data) {
            setSearchData(result.Data);
        }
    }
    const handleClickRow = (data) => {
        onSelect?.(data);
        handleClose();
    }
    const handleClose = () => {
        setShow(false);
        searchDataRef.current = {};
    }

    return (
        <Modal show={show}>
            <Modal.Header className="headerStyle">
                فرم‌های مرتبط
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={handleClose} />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                <Row className="rowBorder">
                    <Col md={6}>
                        <label>نوع فرم:</label>
                        <select className="search-input" name="entityType" onChange={handleChange}>
                            <option value="">انتخاب کنید</option>
                            <option value="Customer">مشتریان</option>
                            <option value="PreCustomer">مشتریان بالقوه</option>
                            <option value="Event">رویدادها</option>
                            <option value="Service">سرویس‌ها</option>
                            <option value="Invoice">فاکتورها</option>
                            <option value="FormalInvoice">فاکتورهای رسمی</option>
                            {/* <option value="InterOfficeMessage">نامه‌های اداری</option> */}
                            {/* <option value="Cheque">چک‌ها</option> */}
                            <option value="ChequeFunction">عملیات چک</option>
                            {/* <option value="BoM">فرم‌های تولید</option> */}
                            <option value="AccDocument">سندهای حسابداری</option>
                            <option value="Ticket">تیکت‌ها</option>
                            <option value="Staff">نمایندگان، تکنسین‌ها، پرسنل</option>
                            {/* <option value="GuaranteeCard">کارت‌های گارانتی</option> */}
                            {/* <option value="SaleCampaign">کمپین فروش</option> */}
                            {/* <option value="Complaint">شکایات</option> */}
                            {/* <option value="Product">کالاها</option> */}
                            {/* <option value="Storage">انبارها</option> */}
                            {/* <option value="User">کاربران</option> */}
                        </select>
                    </Col>
                    <Col md={6}>
                        <label>شماره فرم:</label>
                        <input className="search-input" name="code" onChange={handleChange} />
                    </Col>
                </Row>
                <Button onClick={handleSearch} className="p-2 mt-2 mb-2 w-100">جستجوی فرم</Button>
                <div className="scThin" style={{ overflow: "auto", maxHeight: "200px" }}>
                    <Table className="mb-0" >
                        <thead>
                            <tr >
                                <th style={{ position: "sticky", top: 0, backgroundColor: "#b6b6b6" }}>نوع فرم</th>
                                <th style={{ position: "sticky", top: 0, backgroundColor: "#b6b6b6" }}>شماره/شناسه فرم</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isPending ?
                                <tr>
                                    <td colSpan={2} className="text-center">
                                        <Loader type="BallTriangle" width={25} height={25} color="#bb1370" />
                                    </td>
                                </tr> :
                                <>
                                    {Array.isArray(searchData) &&
                                        searchData.map((data, i) =>
                                            <tr key={i} onClick={() => handleClickRow(data)} className="resultTableRow">
                                                <td>{data.PEntityType}</td>
                                                <td>{data.Code}</td>
                                            </tr>)
                                    }
                                </>}
                        </tbody>
                    </Table>
                </div>
            </Modal.Body>
        </Modal>
    )
}